import {
    GET_ALL_CLIENTS,
    GET_ALL_CLIENTS_SUCCESS,
    CREATE_CLIENT,
    CREATE_CLIENT_SUCCESS,
    EDIT_CLIENT,
    EDIT_CLIENT_SUCCESS,
    DELETE_CLIENT,
    DELETE_CLIENT_SUCCESS,
    GET_CLIENT_BY_ID,
    GET_CLIENT_BY_ID_SUCCESS
} from "../storeTypes";

export const getAllClients = (payload) => {
    return {
        type: GET_ALL_CLIENTS,
        payload: payload,
    }
};
export const getAllClientsSuccess = (payload) => {
    return {
        type: GET_ALL_CLIENTS_SUCCESS,
        payload: payload,
    }
};

export const createClient = (payload, callback) => {
    return {
        type: CREATE_CLIENT,
        payload: payload,
        callback: callback
    }
};
export const createClientSuccess = (payload) => {
    return {
        type: CREATE_CLIENT_SUCCESS,
        payload: payload,
    }
};

export const editClient = (payload, callback) => {
    return {
        type: EDIT_CLIENT,
        payload: payload,
        callback: callback
    }
};
export const editClientSuccess = (payload) => {
    return {
        type: EDIT_CLIENT_SUCCESS,
        payload: payload,
    }
};

export const deleteClient = (id, callback) => {
    return {
        type: DELETE_CLIENT,
        payload: id,
        callback: callback
    }
}
export const deleteClientSuccess = (id) => {
    return {
        type: DELETE_CLIENT_SUCCESS,
        payload: id
    }
}

export const getClientById = (id) => {
    return {
        type: GET_CLIENT_BY_ID,
        payload: id
    }
}
export const getClientByIdSuccess = (payload) => {
    return {
        type: GET_CLIENT_BY_ID_SUCCESS,
        payload: payload
    }
}
